import { getIncodeClient } from '@egw/risk-service'
import { Logger } from '@egw/logger'
import { type FC, useEffect, useRef } from 'react'

const log = new Logger('MobileRedirect')

interface MobileRedirectProps {
  session: { token: string }
  flowId: string
  onSuccess: (result?: any) => void
  onError?: (error: any) => void
}

export const MobileRedirect: FC<MobileRedirectProps> = ({ session, flowId, onSuccess, onError }) => {
  const containerRef = useRef<HTMLDivElement>(null)
  const isMounted = useRef(false)

  log.info('MobileRedirect: Starting mobile redirect render')

  useEffect(() => {
    if (isMounted.current || !session || !containerRef.current || !flowId) {
      return
    }

    try {
      const incodeClient = getIncodeClient()

      // Check if the client has isDesktop method, otherwise use platform detection
      const isDesktop = incodeClient.isDesktop()

      console.log('isDesktop:', isDesktop)

      if (isDesktop) {
        log.info('MobileRedirect: Desktop detected, rendering mobile redirect')

        incodeClient.renderRedirectToMobile(containerRef.current, {
          onSuccess: (result) => {
            log.info('MobileRedirect: Success from mobile flow')
            onSuccess(result)
          },
          session,
          flowId,
        })
      } else {
        log.info('MobileRedirect: Mobile detected, calling success directly')
        // If already on mobile, just call success to continue with normal flow
        onSuccess()
      }
    } catch (error) {
      log.error('MobileRedirect: Error during mobile redirect rendering', error)
      if (onError) {
        onError(error)
      }
    }

    isMounted.current = true
  }, [session, flowId, onSuccess, onError])

  return (
    <div
      ref={containerRef}
      className="w-full flex items-center justify-center"
      style={{ background: '#fff !important' }}
    />
  )
}
